export const FILL_LIST = 'FILL_LIST';
export const ASSIGN_MENU_ELEMENT = 'ASSIGN_MENU_ELEMENT';
export const UNASSIGN_MENU_ELEMENT = 'UNASSIGN_MENU_ELEMENT';
